// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"332":"737fd7b4","453":"6471b063","633":"aa485a6d"}[chunkId] + ".chunk.js";
};